import { ReactComponent as CarIcon } from "Components/_Shared/Icons/Assets/car.svg";
import { ReactComponent as ChildIcon } from "Components/_Shared/Icons/Assets/child.svg";
import { ReactComponent as FinancialSuccessIcon } from "Components/_Shared/Icons/Assets/financial-success.svg";
import { ReactComponent as HomeIcon } from "Components/_Shared/Icons/Assets/home.svg";
import { ReactComponent as MoneyBoxIcon } from "Components/_Shared/Icons/Assets/money-box.svg";
import { ReactComponent as TargetIcon } from "Components/_Shared/Icons/Assets/target.svg";
import { GoalOverviewType } from "Infrastructure/ApiZfp/Schema";

type Props = {
  type: GoalOverviewType;
};

const getIcon = (type: GoalOverviewType) => {
  switch (type) {
    case GoalOverviewType.pension: {
      return <FinancialSuccessIcon />;
    }
    case GoalOverviewType.financial_reserve: {
      return <MoneyBoxIcon />;
    }
    case GoalOverviewType.housing: {
      return <HomeIcon />;
    }
    case GoalOverviewType.vehicle: {
      return <CarIcon />;
    }
    case GoalOverviewType.children: {
      return <ChildIcon />;
    }
    case GoalOverviewType.other: {
      return <TargetIcon />;
    }
    default: {
      return <TargetIcon />;
    }
  }
};

export const GoalIcon = ({ type }: Props) => {
  return getIcon(type);
};
